import { usePurchaseContext } from '~/purchase/context';
import { Trans } from '~/common/context';

function PurchaseTableHeader() {
  const { state } = usePurchaseContext();

  return (
    <thead className='align-middle'>
      <tr>
        <th id='product' className='px-2 text-center '>
          <Trans i18nKey='app.purchase.table.product' />
        </th>
        <th className='px-2 text-center' id='detail'>
          <Trans i18nKey='app.common.description' />
        </th>
        <th className='px-2 text-center' id='bf-price'>
          <Trans i18nKey='app.common.price.bf' />
        </th>

        {state.targetCustomer?.hasInternalStocks && (
          <th className='px-2 text-center' id='customer-stock'>
            <Trans i18nKey='app.common.customer.local_stock' />
          </th>
        )}

        <th className='px-2 text-center' id='supplier'>
          <Trans i18nKey='app.purchase.table.supplier' />
        </th>
        <th className='px-2 text-center' id='delivery'>
          <Trans i18nKey='app.common.estimation_delivery' />
        </th>

        <th className='px-2 text-center' id='stock'>
          <Trans i18nKey='app.purchase.table.availability' />
        </th>
        <th className='px-2 text-center' id='quantity'>
          <Trans i18nKey='app.common.quantity' />
        </th>
        <th className='px-2 text-center' id='unit-price'>
          <Trans i18nKey='app.purchase.table.price' />
        </th>
        <th className='px-2 text-center' id='action'>
          <Trans i18nKey='app.common.actions' />
        </th>
      </tr>
    </thead>
  );
}

export default PurchaseTableHeader;
